import { useParams } from "react-router-dom";

// Components
import GameModeButtons from "components/organisms/GameModeButtons";

// Constants
import { GET_PARAMS } from "constants/popupConfig";

// Hooks
import { useCheckBalance } from "hooks/useCheckBalance";
import useQueryParam from "hooks/useQueryParam";
import { useLoadGame } from "hooks/useLoadGame";

// Types
import { GAME_MODE } from "types/Games";

const GameModeButtonsConainer = () => {
  const mode = useQueryParam(GET_PARAMS.MODE);

  const [loadGame] = useLoadGame();
  const checkBalance = useCheckBalance();

  const params = useParams();

  async function handleDemoInit() {
    if (params.game) {
      await loadGame(GAME_MODE.DEMO, params.game);
    }
  }
  async function handleRealInit() {
    const isBalancePositive = checkBalance();
    // eslint-disable-next-line sonarjs/no-collapsible-if
    if (isBalancePositive) {
      if (params.game) {
        await loadGame(GAME_MODE.REAL, params.game);
      }
    }
  }

  return (
    <GameModeButtons
      mode={mode}
      // eslint-disable-next-line react/jsx-no-bind
      onDemoInit={handleDemoInit}
      // eslint-disable-next-line react/jsx-no-bind
      onRealInit={handleRealInit}
    />
  );
};

export default GameModeButtonsConainer;
